import React from "react";
import PropTypes from "prop-types";
import { isMobile } from "react-device-detect";

export default function Splash({ data, handleClose }) {

  const { mobileImageUrl, desktopImageUrl, header, subHeader, buttonUrl, buttonImage, termsText, id, endDateTime } = data;

  const imageUrl = isMobile ? mobileImageUrl : desktopImageUrl;
  const [first, rest] = header.split(/ (.*)/);

  const splashTerms =
    <div className="splash-terms">
      {termsText}
      <span className="splash-gambleaware">
              <a href="http://begambleaware.org" title="Be Gamble Aware" target="_blank">
                BEGAMBLEAWARE.ORG
              </a>
          </span>
    </div>;

  return (
    <div className="splash">
      <div
        className="splash__wrapper"
        style={{ background: `linear-gradient(-90deg, rgba(27, 60, 123, 0) 0%, #1B3C7B 100%), url(${imageUrl})`, backgroundSize: "cover" }}
      >
        <div className="splash_tint">
          <span className="splash-close" onClick={() => handleClose(id, endDateTime)}>
            <img src="/img/splash/close-icon.svg" alt="Close" height="14" width="46" title="Close"/>
          </span>
          <div className="col1">
            <div className="splash-title">
              <p><span className="header-first-word">{first}</span> {rest}</p>
            </div>
            <div className="splash-body">
              <p>{subHeader}</p>
            </div>
            {splashTerms}
          </div>
          <div className="col2">
            <div className="splash-provided-by">
              <p>Betting provided by </p>
              <img className="splash-skybet-logo" src="/img/splash/skybet-logo.png" alt="Sky Bet Logo" height="14" width="46"/>
            </div>
            <div className="splash-button">
              <a href={buttonUrl} title="Go to offer" target="_blank">
                <img src={buttonImage} alt="Bet Here Button" height="336" width="428"/>
              </a>
            </div>
            {splashTerms}
          </div>
        </div>
      </div>
    </div>
  )
}

Splash.propTypes = {
  data: PropTypes.shape({
    mobileImageUrl: PropTypes.string.isRequired,
    desktopImageUrl: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    subHeader: PropTypes.string.isRequired,
    buttonUrl: PropTypes.string.isRequired,
    buttonImage: PropTypes.string.isRequired,
    termsText: PropTypes.string,
    id: PropTypes.string.isRequired,
    endDateTime: PropTypes.string.isRequired,
  }).isRequired,
  handleClose: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./modules/Common/components/Splash.js